import { trackTemplateApplied, WidgetInputMenuButton } from '@/ui'
import { useAtomValue } from 'jotai'
import { canvasSimulatorTypeAtom } from '../atoms'
import { useCanvasStore } from '../canvas-store'
import { blankTemplate, customDemo1Template, systemDefaultTemplate } from '../templates'
import { useLayerTreeActions } from '../use-layer-tree-actions'

const TEMPLATES = [
	{ id: 'system-default', label: 'Default', template: systemDefaultTemplate },
	{ id: 'custom-demo-1', label: 'Custom Demo 1', template: customDemo1Template },
	{ id: 'blank', label: 'Blank', template: blankTemplate },
]

export function TemplatePicker() {
	const { applyTemplate } = useLayerTreeActions()
	const store = useCanvasStore()
	const simulatorType = useAtomValue(canvasSimulatorTypeAtom, { store })

	const menuItems = TEMPLATES.map(({ id, label, template }) => ({
		id,
		label,
		onSelect: () => {
			applyTemplate(template)
			trackTemplateApplied(id, label, simulatorType)
		},
	}))

	return <WidgetInputMenuButton label="Templates" items={menuItems} />
}
